/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { matchPath, RouteComponentProps, withRouter } from 'react-router';
import { RouterStates } from '../../../definitions/RouterStates';
import { useRootSelector } from '../../../hooks/useRootSelector';
import favicon from './favicon.png';
import { get, compact } from '@utils/lodash';

export namespace AppHeader {
  export type Props = RouteComponentProps<{}>;
}

export const _AppHeader: React.FC<AppHeader.Props> = ({ history, location }) => {
  const { current: task } = useRootSelector(state => state.tasks);
  const [pathname, setPathname] = useState(location.pathname);
  const [title, setTitle] = useState('');
  const taskTitle = get(task, 'template.title');

  const formatTitle = (taskOrPageName?: string) => {
    return compact(['Blend Signing Room', taskOrPageName]).join(' | ');
  };

  const getTitle = () => {
    if (matchPath(pathname, { path: `${RouterStates.ROOM}`, exact: true })) {
      return formatTitle(taskTitle);
    } else if (
      matchPath(pathname, { path: `${RouterStates.PARTICIPANT_SIGNING_ROOM}`, exact: true }) ||
      matchPath(pathname, { path: `${RouterStates.NOTARY_SIGNING_ROOM}`, exact: true })
    ) {
      return formatTitle('Signing');
    } else if (
      matchPath(pathname, { path: `${RouterStates.PARTICIPANT_ROOM_FINISH}`, exact: true }) ||
      matchPath(pathname, { path: `${RouterStates.NOTARY_ROOM_FINISH}`, exact: true }) ||
      matchPath(pathname, { path: `${RouterStates.ROOM_EXIT}`, exact: true })
    ) {
      return formatTitle('End');
    } else if (matchPath(pathname, { path: `${RouterStates.JOURNAL}`, exact: true })) {
      return formatTitle('Journal');
    } else {
      return formatTitle();
    }
  };

  useEffect(() => {
    const newTitle = getTitle();
    setTitle(newTitle);
  }, [taskTitle, pathname]);

  useEffect(() => {
    const historyUnlisten = history.listen(l => {
      setPathname(l.pathname);
    });
    return () => {
      if (!!historyUnlisten) {
        historyUnlisten();
      }
    };
  }, []);
  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
    </Helmet>
  );
};

export const AppHeader = withRouter(_AppHeader);
